import * as React from "react";
import { SegmentedControl as MantineSegmentedControl } from "@mantine/core";
import { useTheme } from "styled-components";
const SegmentedControl = ({
  className = void 0,
  data,
  defaultValue = void 0,
  disabled = false,
  onChange = void 0,
  value = void 0,
  radius = "xs"
}) => {
  const theme = useTheme();
  return /* @__PURE__ */ React.createElement(
    MantineSegmentedControl,
    {
      color: theme.colors.variant.info,
      className,
      data,
      defaultValue,
      radius,
      disabled,
      value,
      onChange,
      styles: { label: { marginBottom: 0 } }
    }
  );
};
export default SegmentedControl;
